import React from 'react';

export class ErrorBoundary extends React.Component {
    state = {hasError: false};

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        // TODO: forward to Airbrake once wired up
        console.error('Uncaught rendering error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{padding: '40px', textAlign: 'center', fontFamily: 'sans-serif'}}>
                    <h1>Something went wrong.</h1>
                    <p>Please refresh the page. If the problem persists, visit <a href="https://shop.snapplify.com">shop.snapplify.com</a>.</p>
                </div>
            );
        }
        return this.props.children;
    }
}
